module.exports = __webpack_public_path__ + "img/home_banner1.8438c260.png";